import { Popover, Slider } from "@blueprintjs/core"
import { ChangeEvent, CSSProperties, useState } from "react"
import { __, getCssDemention } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, LANDING_TYPE_CONTENT, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IHoverElement, ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "./utils/updateSection"
import { OFFLINE_SECTIONS } from "./landing-edit-overlay/OfflineSections"

/* Protopia Ecosystem component */

enum Distination {
    TOP= "Top",
    LEFT= "Left",
    BOTTOM= "Bottom",
    RIGHT= "Right",
}
const D = 35
export interface IContentHoverMarginFormProps {
   
}
const ContentHoverMarginForm = (props: IContentHoverMarginFormProps): JSX.Element => {
    const currentLanding:ILanding                   = useLandingStore((state: ILandingStore) => state.currentLanding)
    const hoverElement: IHoverElement | undefined   = useLandingStore((state:ILandingStore) => state.hoverElement ) 
    const section: ILandingSection | undefined      = currentLanding.sections.find( section => section.id === hoverElement?.sectionId )
    const meat                                      = section?.data.find( meat => meat.id === hoverElement?.id )
    const containerStyle: CSSProperties             = { ...meat?.containerStyle }

    const onShowChange = (value: number, distination: Distination) => { 
        return
    }
    const onUpdate = (value: number, distination: Distination) => { 
        const prevData = JSON.parse( JSON.stringify( section )) 
        containerStyle.marginRight = containerStyle.marginRight || containerStyle.margin || 0
        containerStyle.marginLeft = containerStyle.marginLeft || containerStyle.margin || 0
        containerStyle.marginTop = containerStyle.marginTop || containerStyle.margin || 0
        containerStyle.marginBottom = containerStyle.marginBottom || containerStyle.margin || 0
        delete containerStyle.margin
        containerStyle[`margin${distination}`] = value
        
        const newValue: ILandingSection = {
            ...section,
            data: (section?.data || []).map(meat => {
                if(meat.id === hoverElement?.id) { 
                    return {
                        ...meat,
                        containerStyle 
                    }
                }
                return meat
            }) 
        } as ILandingSection 
        
        const historyStep: IHistoryStep ={
            data: newValue,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "update meat container"
        }
        updateSection( newValue, historyStep)
    }
    switch(hoverElement?.selectType) {
        case SELECT_TYPE.CONTENT:
            if(OFFLINE_SECTIONS.includes( meat?.type || LANDING_TYPE_CONTENT.NONE )) { 
                return <></>
            }
            return <div className='landing-content-hover-margin-form-container'>
                <SingleMarginForm hoverElement={hoverElement} onShowChange={onShowChange} onUpdate={onUpdate} distination={Distination.TOP} />
                <SingleMarginForm hoverElement={hoverElement} onShowChange={onShowChange} onUpdate={onUpdate} distination={Distination.LEFT} />
                <SingleMarginForm hoverElement={hoverElement} onShowChange={onShowChange} onUpdate={onUpdate} distination={Distination.BOTTOM} />
                <SingleMarginForm hoverElement={hoverElement} onShowChange={onShowChange} onUpdate={onUpdate} distination={Distination.RIGHT} /> 
            </div>
        default:
            return <></>
    } 
}
export default ContentHoverMarginForm

interface ISingleMarginProps {
    hoverElement: IHoverElement
    onShowChange: (value: number, distination: Distination) => void
    onUpdate: (value: number, distination: Distination) => void
    distination: Distination
}
export const SingleMarginForm = ({ hoverElement,  onShowChange, onUpdate, distination }:ISingleMarginProps) : JSX.Element => {                 
    const dist                          = distination.toLowerCase()
    const currentLanding:ILanding       = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section                       = currentLanding.sections.find( section => section.id === hoverElement.sectionId )
    const meat                          = section?.data.find( meat => meat.id === hoverElement.id )
    const containerStyle: CSSProperties = { ...meat?.containerStyle }
    const [margin, setMargin]           = useState<string>( getCssDemention( containerStyle.margin || containerStyle[`margin${distination}`] || 0) )                    
    const [_margin, set_margin]         = useState<number>( parseInt( (containerStyle.margin || containerStyle[`margin${distination}`] || "0").toString() ) )   
    
    const onRelease = (value: number) => { 
        onUpdate(value, distination)
    }
    const onChange = (value: number) => {
        setMargin(getCssDemention( value ))
        set_margin( parseInt( (value.toString() ) ))
        onShowChange(value, distination)
    }
    let style: any
    switch(distination) {
        case Distination.TOP:
            style = {
                height: margin,
                top:  -_margin,
                left: D// hoverElement.bound.width! / 2
            }
            break
        case Distination.BOTTOM:
            style = {
                height: margin,
                top: hoverElement.bound.height ,
                left: D// hoverElement.bound.width! / 2
            }
            break
        case Distination.LEFT:
            style = {
                width: margin,
                left: -_margin,
                top: D// hoverElement.bound.height! / 2
            }
            break
        case Distination.RIGHT:
            style = {
                width: margin,
                left: hoverElement.bound.width,
                top: D// hoverElement.bound.height! / 2
            }
            break
    }

    const hor       = [Distination.LEFT, Distination.RIGHT].includes(distination) ? "height" : "width" 
    const transform = hor === "height" 
        ? 
        `translateY(-${D}px)` 
        : 
        `translateX(-${D}px)`
    return <div 
        className={ `m-margin-${dist}` } 
        style={ style }
    >
        <MarginHandler value={ _margin } title={ `Margin ${dist}` } onChange={ onChange } onRelease={ onRelease } /> 
        <div className="margin-dot" >
            <div
                style={{
                    width: 1,
                    height: 1,
                    transform,
                    [ hor ] : hoverElement.bound[ hor ],
                }}
                className="current-hover-margin"
            />
        </div>
    </div>
}
export interface IMarginHandlerProps {
    value: number
    title: string 
    onChange: (value: number) => void
    onRelease: (value: number) => void
}
export const MarginHandler = (props:IMarginHandlerProps): JSX.Element => {
    const onInputChange = ( evt: ChangeEvent<HTMLInputElement> ) => {
        const value: number = Number(evt.currentTarget.value)
        onRelease(value)
    }   
    const onChange = (value: number) => { 
        props.onChange( value )
    }
    const onRelease = (value: number) => { 
        props.onRelease( value )
    }
    return <div className="margin-label" title={__( props.title )}>
        <Popover
            content={
                <div className="p-3 bg-plain width-300 d-flex ">
                    <Slider
                        min={0}
                        max={200}
                        stepSize={1}
                        labelStepSize={50}
                        value={props.value}
                        onChange={ onChange }
                        onRelease={ onRelease }
                        className="mr-3"
                    />
                    <input
                        type="number"
                        value={props.value}
                        className="width-75 form-control input dark"
                        onChange={onInputChange}
                    />
                </div>
            }
        >
            <div className="margin-label-label">
                {  props.value }
            </div> 
        </Popover>
    </div>
}
